import { render, staticRenderFns } from "./priceLog.vue?vue&type=template&id=34839212&"
import script from "./priceLog.vue?vue&type=script&lang=js&"
export * from "./priceLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports